import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate' // 数据持久化

const store = createPinia()

// 创建安全的存储包装器，避免Android 10的MMKV兼容性问题
const safeStorage = {
  getItem: (key: string) => {
    try {
      return uni.getStorageSync(key)
    } catch (error) {
      console.warn('Storage getItem failed:', error)
      return null
    }
  },
  setItem: (key: string, value: string) => {
    try {
      uni.setStorageSync(key, value)
    } catch (error) {
      console.warn('Storage setItem failed:', error)
      // 如果存储失败，尝试使用异步存储作为备选
      try {
        uni.setStorage({ key, data: value })
      } catch (asyncError) {
        console.error('Async storage also failed:', asyncError)
      }
    }
  },
}

store.use(
  createPersistedState({
    storage: safeStorage,
  }),
)

export default store

// 模块统一导出
export * from './user'
